export enum ActionStatus {
  IMMEDIATE,
  IMPROVE,
  OPTIMAL,
  LONG_TERM,
  COMPLETED,
}
